import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ADD_SERVICES_TYPE_HERE = "ADD_SERVICES_TYPE_HERE";
export const ADD_SERVICES_TYPE_HERE_LOADING =
"ADD_SERVICES_TYPE_HERE_LOADING";
export const ADD_SERVICES_TYPE_HERE_LOADING_FAILED =
"ADD_SERVICES_TYPE_HERE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const addServiceTypeLoading = ms => ({
    type: ADD_SERVICES_TYPE_HERE_LOADING,
    payload: ms
    });
    
    export const addServiceTypeLoadingFailed = ms => ({
    type: ADD_SERVICES_TYPE_HERE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function addServiceType(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/serviceType/createServiceType`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(addServiceTypeLoading());
  
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200 || response.status == 201) {
     console.log(response,"response addServiceType")
    dispatch({
    type: ADD_SERVICES_TYPE_HERE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        addServiceTypeLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(addServiceTypeLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(addServiceTypeLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(addServiceTypeLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


